// One home for the label so the grid cell, its filter options and the renderer cannot disagree.

export const UPSTACK_ORIGIN = 'UPSTACK';
export const UPSTACK_CONVERTED_ORIGIN = 'UPSTACK Converted';

const SALESFORCE_MIGRATION = 'salesforce_migration';

type OriginRow = { origin?: unknown; outside_inventory_schema_id?: unknown; entry_method?: unknown };

export const isConvertedRecord = (entryMethod?: unknown): boolean => entryMethod === SALESFORCE_MIGRATION;

// Rows fetched outside the inventory store never pass through normalizeInventoryAsset, so they carry no flag.
export const isUpstackSourced = (row?: OriginRow): boolean =>
  row?.origin !== undefined && row?.origin !== null ? !!row.origin : !row?.outside_inventory_schema_id;

export const getOriginLabel = (upstackSourced: boolean, converted: boolean, accountName?: string): string => {
  if (converted) return UPSTACK_CONVERTED_ORIGIN;
  if (upstackSourced) return UPSTACK_ORIGIN;
  return accountName || '';
};

export const getOriginDescription = (upstackSourced: boolean, converted: boolean): string => {
  if (converted) return 'Inventory was converted to a portal record by UPSTACK';
  if (upstackSourced) return 'Inventory is UPSTACK sourced';
  return 'Inventory is not UPSTACK sourced';
};
